import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
export function useHighestPermissionText(permissions) {
    const { t } = useDocumentLibraryTranslations();
    if (permissions && permissions.length > 0) {
        if (permissions.includes('modify')) {
            return t('documents.modify');
        }
        if (permissions.includes('write')) {
            return t('documents.write');
        }
        if (permissions.includes('read')) {
            return t('documents.read');
        }
    }
    return '';
}
